<template>
    <div class="Cluster">
        <el-card class="box-card">
            <div class="sub-menu-section">
                <div class="flex">
                    <!-- <div class="tab-link cursor-pointer" :class="{'active-tab-link' : active_tab_link == 'AVAILABILITY'}" @click="setActiveTabLink('AVAILABILITY')">
                        AVAILABILITY
                    </div> -->
                    <div class="tab-link cursor-pointer ml-6" style="position: relative;" :class="{'active-tab-link' : active_tab_link == 'MANAGE_REQUEST'}" @click="setActiveTabLink('MANAGE_REQUEST')">
                        <div>MANAGE REQUESTS</div>
                        <el-tag type="danger" effect="dark" size="mini" style="position: absolute; top: -12px; right: -25px;">{{ total_request_to_manage }}</el-tag>
                    </div>
                </div>
            </div>

            <div class="mt-6 flex">
                <div>
                    <label>Select Outlet</label>
                    <el-select v-model="select_store" placeholder="Select store" name="Select Store" size="medium" class="store-input" filterable @change="selectStore()">
                        <el-option v-for="(store, store_index) in outlets_list" :key="store_index" :value="store.id" :label="store.name" class="capitalize"></el-option>
                    </el-select>
                </div>

                <div v-if="active_tab_link == 'AVAILABILITY'" class="ml-6">
                    <label>Select Date</label>
                    <el-date-picker
                        v-model="select_date" type="date" size="medium" placeholder="Select date" style="width: 200px;" @change="changeDate()">
                    </el-date-picker>
                </div>

                <div v-if="active_tab_link == 'MANAGE_REQUEST'" class="ml-6">
                    <label>Select Week</label>
                    <el-date-picker
                        v-model="select_week"
                        type="week"
                        size="medium"
                        placeholder="Select week"
                        style="width: 250px;"
                        :format="custom_date_format"
                        :picker-options="date_range_options"
                        @change="showDayOfWeek(select_week)"
                    >
                    </el-date-picker>
                </div>
            </div>

            <!-- <div v-if="active_tab_link == 'AVAILABILITY'" class="mt-8" v-loading="is_cluster_availability_loading">
                <ClusterAvailability :available-cluster-list="available_cluster_list" :functions_list="functions_list"
                :select-store="select_store" :staff-data="staffData" :store-time-slots="store_time_slots"></ClusterAvailability>
            </div> -->

            <div v-if="active_tab_link == 'MANAGE_REQUEST'" class="mt-8" v-loading="is_manage_cluster_request_loading">
                <ManageClusterRequest :manage-request-list="manage_request_list"></ManageClusterRequest>
            </div>
        </el-card>
    </div>
</template>

<script>
import moment from 'moment';
import ClusterAvailability from '../clusterAvailability/ClusterAvailability.vue';
import ManageClusterRequest from '../manageClusterRequest/ManageClusterRequest.vue';
import labourPlanningService from '../../../../services/labourPalnningService';
import axios from 'axios';

export default {
    name: 'Cluster',

    components: {
        ClusterAvailability,
        ManageClusterRequest
    },

    data() {
        return {
            active_tab_link: 'MANAGE_REQUEST',
            
            total_request_to_manage: 0,
            
            select_date: new Date(),
            select_week: new Date(),

            custom_date_format: '',
            firstdays: '',
            lastdays: '',
            current_week_no: '',
            date_range_options: {
				firstDayOfWeek: 1
			},
            
            select_store: '',
            outlets_list: [],
            functions_list: [],

            available_cluster_list: [],
            manage_request_list: [],

            is_cluster_availability_loading: false,
            is_manage_cluster_request_loading: false,
            staffData: {},
            store_time_slots: []
        }
    },

    mounted() {
        this.getOutletsList();
        this.showDayOfWeek();
    },

    methods: {
        selectStore(){
            if(this.active_tab_link == 'AVAILABILITY'){
                if(this.select_store){
                    this.fillClusterAvailibilityTable();
                }
			}else{
                if(this.select_store){
                    this.fillMangeClusterRequestTable();
                }
			}
            if(this.select_store) {
                this.getEmpShiftData();
                this.getStoreTimings();
            }
            
            localStorage.setItem('cluster_selected_store', this.select_store);
            this.getFunctions();    //api to get functions list
        },
        getEmpShiftData(){
            let payload = {
                outlet_id: this.select_store,
            };
            labourPlanningService.getStaffDetails(payload).then((res)=>{
                this.staffData = JSON.parse(res.data);
            }).catch((err)=>{
                console.error(err)
            });
        },
        getStoreTimings() {
            let payload = {
                start_date: this.select_date,
                end_date: this.select_date,
                store: this.select_store
            }
            labourPlanningService.getStoreTimings(payload).then((response) => {
                this.store_time_slots = JSON.parse(response.data);
            }).catch((err) => {
                console.error(err);
            });
        },
        changeDate(){
            // called function to fill table
            this.fillClusterAvailibilityTable();
        },
        

        setActiveTabLink(link){
            if(link == 'AVAILABILITY'){
                this.active_tab_link = 'AVAILABILITY';

                if(this.select_store){
                    this.fillClusterAvailibilityTable();
                }
			}else{
                this.active_tab_link = 'MANAGE_REQUEST';

                if(this.select_store){
                    this.fillMangeClusterRequestTable();
                }
			}

        },

        //function to fill cluster availlability table
        async fillClusterAvailibilityTable(){
            this.is_cluster_availability_loading = true;    //enabled loader
            
            this.available_cluster_list = [];
            
            let store_params = {
                outlet: this.select_store,
                cluster_outlet: "",
                start_date: moment(this.select_date).format('YYYY-MM-DD'),
                end_date: moment(this.select_date).format('YYYY-MM-DD')
            }

            let emp_availibility_params = {
                outlet: this.select_store,
                cluster_outlet: "",
                start_date: moment(this.select_date).format('YYYY-MM-DD'),
                end_date: moment(this.select_date).format('YYYY-MM-DD')
            }

            let store_details_res = await this.getClusterStoreDetailsByOutlet(store_params);
            
            let emp_availibility_res = await this.getEmpAvailabilityForCluster(emp_availibility_params);

            if(store_details_res.status == 200 && emp_availibility_res.status == 200){
                let store_list = JSON.parse(store_details_res.data);
                let emp_list = JSON.parse(emp_availibility_res.data);

                if(store_list.length){
                    let filtered_store = _.uniqBy(store_list, 'store');

                    for(let i=0; i<filtered_store.length; i++){
                        let obj = {};
                        obj.store_name = filtered_store[i].store_name;
                        obj.store_id = filtered_store[i].store;
                        obj.emp_list = [];
                        
                        let filterd_employees = store_list.filter(e => {return e.store == filtered_store[i].store});

                        for(let j=0; j<filterd_employees.length; j++){
                            let emp_obj = {};
                            emp_obj.full_name = filterd_employees[j].full_name;
                            emp_obj.function = filterd_employees[j].function;
                            emp_obj.function_name = filterd_employees[j].function_name;
                            emp_obj.employee_type = filterd_employees[j].employee_type;
                            emp_obj.gender = filterd_employees[j].gender;
                            emp_obj.id = filterd_employees[j].id;
                            emp_obj.store = this.select_store;
                            emp_obj.store_name = this.outlets_list.filter(e => {return e.id == this.select_store})[0].name;
                            // emp_obj.prefer_start_time = filterd_employees[j].prefer_start_time;
                            // emp_obj.prefer_end_time = filterd_employees[j].prefer_end_time;

                            // getting emp_list as object of dates
                            for(let key in emp_list){
                                let filterd_emp_from_availibility_list = emp_list[key].filter(e => {
                                    // console.log(e.employee, filterd_employees[j].id)
                                    return e.employee == filterd_employees[j].id;
                                })[0];


                                if(filterd_emp_from_availibility_list){
                                    // key to show is request avialable 
                                    let day_type = filterd_emp_from_availibility_list.day_type;
                                    let request_status = filterd_emp_from_availibility_list.status;
    
                                    emp_obj.status = (day_type == 'shift') ? 'AVAILABLE' : (day_type == 'weekly_off' || day_type == 'leave') ? 'UNAVAILABLE' : (day_type == 'cluster_requested' && request_status == 'pending') ? 'PENDING' : ((day_type == 'cluster_requested' || day_type == 'assigned') && request_status == 'approved') ? 'APPROVED' : (day_type == 'cluster_requested' && request_status == 'rejected') ? 'REJECTED' : '';
    
                                    emp_obj.start_time = filterd_emp_from_availibility_list.start_time;
                                    emp_obj.end_time = filterd_emp_from_availibility_list.end_time;
    
                                    emp_obj.request_id = filterd_emp_from_availibility_list.request_id;

                                    // Split shift and breaks added
                                    console.log(filterd_emp_from_availibility_list, 'filterd_emp_from_availibility_list')
                                    emp_obj.split_shifts = filterd_emp_from_availibility_list.split_shifts;
                                    emp_obj.breaks = filterd_emp_from_availibility_list.breaks;
    
                                    emp_obj.date = key;
                                }else{
                                    emp_obj.status = 'UNAVAILABLE';
    
                                    emp_obj.start_time = '';
                                    emp_obj.end_time = '';
    
                                    emp_obj.request_id = '';
    
                                    emp_obj.date = key;
                                }

                            }

                            obj.emp_list.push(emp_obj);
                        }

                        this.available_cluster_list.push(obj);
                    }
                }
            }
            this.is_cluster_availability_loading = false;    //disabled loader
        },

        //function to fill manage cluster request table
        async fillMangeClusterRequestTable(){
            this.is_manage_cluster_request_loading = true;    //enabled loader

            this.manage_request_list = [];

            this.total_request_to_manage = 0;

            let request_params = {
                source_outlet: this.select_store,
                start_date: moment(this.firstdays).format('YYYY-MM-DD'),
                end_date: moment(this.lastdays).format('YYYY-MM-DD'),
            }

            let manage_request_res = await this.getManageClusterRequestEmpDetails(request_params);

            if(manage_request_res.status == 200){
                let store_list = JSON.parse(manage_request_res.data);

                let filtered_store = _.uniqBy(store_list, 'requesting_outlet');

                for(let i=0; i<filtered_store.length; i++){
                    let obj = {};
                    obj.store_name = filtered_store[i].requesting_outlet_name;
                    obj.store_id = filtered_store[i].requesting_outlet;
                    obj.emp_list = [];

                    let filterd_employees = store_list.filter(e => {return e.requesting_outlet == filtered_store[i].requesting_outlet});


                    for(let j=0; j<filterd_employees.length; j++){
                        let emp_obj = {};
                        emp_obj = filterd_employees[j];
                        emp_obj.time = `${moment(filterd_employees[j].start_time).format('LT')} - ${moment(filterd_employees[j].end_time).format('LT')}`;
                        
                        emp_obj.duration = moment.duration(moment(filterd_employees[j].end_time, 'YYYY/MM/DD HH:mm').diff(moment(filterd_employees[j].start_time, 'YYYY/MM/DD HH:mm'))).asHours();
                        
                        emp_obj.raw_status = filterd_employees[j].status == 'rejected' ? 'denied' : filterd_employees[j].status;
                        
                        emp_obj.status = filterd_employees[j].status == 'rejected' ? 'denied' : filterd_employees[j].status;
                        
                        // emp_obj.date = filterd_employees[j].date,
                        
                        // emp_obj.full_name = filterd_employees[j].employee_name,
                        
                        // emp_obj.time = `${moment(filterd_employees[j].start_time).format('LT')} - ${moment(filterd_employees[j].end_time).format('LT')}`;
                        
                        // emp_obj.duration = moment.duration(moment(filterd_employees[j].end_time, 'YYYY/MM/DD HH:mm').diff(moment(filterd_employees[j].start_time, 'YYYY/MM/DD HH:mm'))).asHours();

                        // emp_obj.status = filterd_employees[j].status;

                        // emp_obj.raw_status = filterd_employees[j].status;
                        
                        // emp_obj.emp_id = filterd_employees[j].employee;
                        
                        // emp_obj.id = filterd_employees[j].id;

                        // emp_obj.cluster_id = filterd_employees[j].cluster;

                        obj.emp_list.push(emp_obj);

                        obj.emp_list = obj.emp_list.sort((a, b) => new Date(b.date) - new Date(a.date));

                        if(emp_obj.status == 'pending'){
                            this.total_request_to_manage = this.total_request_to_manage + 1;
                        }
                    }

                    this.manage_request_list.push(obj);
                }
            }

            this.is_manage_cluster_request_loading = false;    //disabled loader
        },

        // api to get all outlets list
		getOutletsList() {
			labourPlanningService.getAllStoreData()
            .then(response => {
                if(response.status == 200){
                    let all_outlets_list = JSON.parse(response.data);

                    if(all_outlets_list.length){
                        this.outlets_list = all_outlets_list.filter(e => {
                            if (e.type == "store") {
                                return e;
                            }
                        });

                        let checkLocalStorage = localStorage.getItem('cluster_selected_store');
                        if(checkLocalStorage) {
                            this.select_store = localStorage.getItem('cluster_selected_store');
                        } else {
                            this.select_store = this.outlets_list[0].id;
                            localStorage.setItem('cluster_selected_store', this.select_store);
                        }

                        this.selectStore();
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },

        getFunctions(){
            let params = {
				outlet_id: this.select_store
			};
			labourPlanningService.getWorkArea(params)
				.then(response => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						this.functions_list = res;
					}
				})
				.catch(err => {
					console.log(err);
				});
        },

		// api to get cluster store details
        getClusterStoreDetailsByOutlet(params) {
			return labourPlanningService.getClusterEmployeesForOutlet(params)
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

		// api to get avilable employee list
        getEmpAvailabilityForCluster(params) {
			return labourPlanningService.getEmpAvailabilityForCluster(params)
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

		// api to get manage cluster request emp details
        getManageClusterRequestEmpDetails(params) {
			return labourPlanningService.getClusterRequestList(params)
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

        showDayOfWeek(select_week) {
			let date = "";

			//checked if week is available in localstorage then set took week from there
			// if not available then assigned selected week from date picker
			//by default on page load cleared localstorage in beforeRouteEnter hook and assigned current date as week
            // Check if the 'cluster_selected_week' is in localStorage
            let localStorageWeek = localStorage.getItem('cluster_selected_week');

            if (select_week) {
                // If 'select_week' is defined, save it in localStorage and use it
                localStorage.setItem('cluster_selected_week', select_week);
                this.select_week = new Date(select_week);
                date = this.select_week;
            } else if (localStorageWeek) {
                // If 'select_week' is not defined, but 'cluster_selected_week' is in localStorage, use it
                this.select_week = new Date(localStorageWeek);
                date = this.select_week;
            } else {
                // If neither 'select_week' nor 'cluster_selected_week' is available, use the current date
                this.select_week = new Date();
                date = this.select_week;
            }


			var dt = new Date(date); // current date of week
			var currentWeekDay = dt.getDay();
			var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
			var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
			var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));

			this.firstdays = moment(wkStart).format("YYYY-MM-DD");
			this.lastdays = moment(wkEnd).format("YYYY-MM-DD");

			this.custom_date_format = `${this.firstdays} To ${this.lastdays}`;
			
            // called fill manage cluster emp details
            if(this.select_store && this.active_tab_link == 'MANAGE_REQUEST'){
                this.fillMangeClusterRequestTable();
            }
		},
    },
}
</script>
<style lang="scss" scoped>
.Cluster{
    .sub-menu-section{
        display: flex;
        width: 100%;
        align-items: center;
    }
    .tab-link {
        font-size: 0.9rem;
        padding: 0 0 5px 0;
        margin: 0 30px 0 0;
    }
    .active-tab-link {
        font-size: 0.9rem;
        color: #E29D5A;
        border-bottom: 2px solid #E29D5A;
    }
    label{
        display: block;
        font-size: 0.8rem;
        font-weight: bold;
        margin-bottom: 5px;
    }
}
</style>
<style lang="scss">
.Cluster{
    .store-input{
        .el-input__inner{
            text-transform: capitalize;
        }
    }
}
</style>